import { apiConf as api } from 'commons';

export const fetchCustomerContracts = (customerId, platform) => {
  return api.superFetch({ url: `organisations/${customerId}/contracts`, platform });
};

export const newValorisation = (contractIds, platform) => {
  return api.superFetch({ url: "valorisations", body: contractIds, method: 'POST', platform });
};